import React, { useState, useEffect } from "react";
import Input from "components/ui/Input";
import Button from "components/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  updateShippingService,
  getShippingService,
} from "redux/services/general_service";
import { toast } from "react-toastify";

const EditShippingSetting = ({ isOpen, onClose, shippingData }) => {
  const dispatch = useDispatch();
  const { governoratesList } = useSelector((state) => state.general);


  const [costInfo, setCostInfo] = useState("");
  const [expectedTime, setExpectedTime] = useState("");


const [selectedGovernorateId, setSelectedGovernorateId] = useState("");
const [selectedProvinceId, setSelectedProvinceId] = useState("");
const [provinces, setProvinces] = useState([]);

// 2. راقب تغير shippingData وقم بتحديث الـ States
useEffect(() => {
  if (isOpen && shippingData) {
    // استخراج الـ country_id والـ province_id من البيانات القادمة
    const countryId = shippingData?.province?.country_id;
    const provinceId = shippingData?.province_id;

    setSelectedGovernorateId(countryId);
    setSelectedProvinceId(provinceId);


    const selectedGov = governoratesList?.find(gov => gov.id === parseInt(countryId));
    if (selectedGov) {
      setProvinces(selectedGov.provinces || []);
    }
  }
}, [isOpen, shippingData, governoratesList]);

  useEffect(() => {
    if (isOpen && shippingData) {
  
      const parentGov = governoratesList?.find(gov => 
        gov.provinces.some(p => p.id === shippingData.province_id)
      );

      if (parentGov) {
        setSelectedGovernorateId(parentGov.id);
        setProvinces(parentGov.provinces || []);
      }
      
      setSelectedProvinceId(shippingData.province?.id);
      setCostInfo(shippingData.cost_info || "");
      setExpectedTime(shippingData.expected_time || "");
    }
  }, [isOpen, shippingData, governoratesList]);

  const handleGovernorateChange = (e) => {
    const govId = e.target.value;
    setSelectedGovernorateId(govId);
    setSelectedProvinceId(""); 
    const selectedGov = governoratesList?.find(gov => gov.id === parseInt(govId));
    setProvinces(selectedGov ? selectedGov.provinces : []);
  };

  if (!isOpen) return null;

  const handleUpdate = () => {
    const payload = {
      id: shippingData.id, // نحتاج الـ id للتعديل
      data: {
        province_id: selectedProvinceId,
        cost_info: costInfo,
        expected_time: expectedTime,
      }
    };

    dispatch(updateShippingService(payload)).then((response) => {
      // استجابة التعديل غالباً تكون 200 أو حسب الـ API عندك
      if (response.payload?.status === 200 || response.payload?.status === 201) {
        toast.success("تم تحديث معلومات الشحن بنجاح");
        dispatch(getShippingService({ page: 1 }));
        onClose();
      }
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">تعديل إعدادات الشحن</h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">الدولة/المحافظة</label>
            <select
              className="w-full p-2 border rounded-md bg-gray-50"
              value={selectedGovernorateId}
              onChange={handleGovernorateChange}
            >
              <option value="">اختر الدولة</option>
              {governoratesList?.map((gov) => (
                <option key={gov.id} value={gov.id}>
                  {gov.translations?.ar?.name || gov.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">المنطقة</label>
            <select
              className="w-full p-2 border rounded-md"
              value={selectedProvinceId}
              onChange={(e) => setSelectedProvinceId(e.target.value)}
              disabled={!provinces.length}
            >
              <option value="">اختر المنطقة</option>
              {provinces.map((prov) => (
                <option key={prov.id} value={prov.id}>
                  {prov.translations?.ar?.name || prov.name}
                </option>
              ))}
            </select>
          </div>

          <Input
            label="التكلفة"
            value={costInfo}
            onChange={(e) => setCostInfo(e.target.value)}
          />

          <Input
            label="الوقت المتوقع"
            value={expectedTime}
            onChange={(e) => setExpectedTime(e.target.value)}
          />
        </div>

        <div className="flex justify-end space-x-2 mt-6 gap-2">
          <Button variant="outline" onClick={onClose}>إلغاء</Button>
          <Button onClick={handleUpdate}>تحديث البيانات</Button>
        </div>
      </div>
    </div>
  );
};

export default EditShippingSetting;